import { GridRenderCellParams, GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityAutocomplete, CuriosityNamespace } from '@procureai/curiosity-ui-mui';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DefaultDataEditGridConfig } from '~/components/DataGridCustom';
import { defaultTextFieldProps } from '~/components/DataGridCustom/common/defaults';

interface DateEditCellProps<R extends GridValidRowModel> extends GridRenderCellParams<R>, DefaultDataEditGridConfig {
  ns: CuriosityNamespace;
  disabled?: boolean;
}

export const CuriosityAutocompleteCell = <R extends GridValidRowModel & { id: GridRowId } = { id: GridRowId }>({
  colDef,
  getRowIndex,
  keyPrefix,
  languageNamespace,
  ns,
  pathPrefix,
  row,
  textFieldProps,
  disabled,
}: DateEditCellProps<R>) => {
  const p = [...(pathPrefix ?? []), getRowIndex?.(row.id), colDef.field];
  const { t: tPrefix } = useTranslation(languageNamespace, { keyPrefix });

  return (
    <Controller
      name={p.join('.')}
      defaultValue=""
      disabled={disabled}
      render={({ field, fieldState: { error } }) => {
        return (
          <CuriosityAutocomplete
            {...field}
            value={field.value || null}
            fullWidth
            ns={ns}
            simplifyValue
            TextFieldProps={{
              label: tPrefix(colDef.field),
              error: !!error,
              ...defaultTextFieldProps,
              ...textFieldProps,
            }}
          />
        );
      }}
    />
  );
};
